import PageLayout from './layout/PageLayout'
import './HomePage.css';

const HomePage = () => {

    return (
        <PageLayout>
            <div className="home-container">
                <div className="home__terminal-window">
                    <div className="home__terminal-header">
                        <div className="home__terminal-dots">
                            <span className="home__terminal-dot home__terminal-dot--red"></span>
                            <span className="home__terminal-dot home__terminal-dot--yellow"></span>
                            <span className="home__terminal-dot home__terminal-dot--green"></span>
                        </div>
                        <span className="home__terminal-title">si-tracker</span>
                    </div>
                    <div className="home__terminal-body">
                        <img src='/invader.svg' alt="Space Invader" className="home__logo"/>
                        <h1 className="home__title">
                            SI-Tracker<span className="home__cursor"></span>
                        </h1>
                        <p className="home__subtitle">Track Space Invaders street art</p>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};

export default HomePage
